import './component.scss';

export class MainIncludePopupIcons {

    constructor(id, params, result, options) {
        this.id = id
        this.params = params
        this.result = result
        this.options = options
        this.$component = document.getElementById(this.id)

        this.lastScrollY = window.scrollY
        this.fillBlockOffsetTop()

        this.init()
    }

    init() {
        this.initObservers()
    }

    initObservers() {
        let self = this

        document.addEventListener('scroll', () => {
            if (window.scrollY > this.blockOffsetTop) {
                if (false === this.$component.classList.contains('is-show')) {
                    this.$component.classList.add('is-show')
                }
            } else {
                this.$component.classList.remove('is-show')
            }

            // if (this.lastScrollY < window.scrollY) {
            //     this.$component.classList.remove('is-show')
            // } else {
            //     this.$component.classList.add('is-show')
            // }
            // this.lastScrollY = window.scrollY
        })

        document.querySelector('.js-popup-icons-move-to-top').addEventListener('click', () => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            })
        })
    }

    fillBlockOffsetTop() {
        this.$component.style.visibility = 'hidden'
        this.$component.style.position = 'static'
        this.$component.style.top = 'auto'
        this.$component.style.transform = 'translateY(0);'

        let offsetTop = 0;
        let currentElement = this.$component;

        while (currentElement && currentElement !== document.body) {
            offsetTop += currentElement.offsetTop;
            currentElement = currentElement.offsetParent;
        }

        const OFFSET = 150
        this.blockOffsetTop = offsetTop + OFFSET

        this.$component.style.position = null
        this.$component.style.top = null
        this.$component.style.transform = null
        this.$component.style.visibility = null
    }
}
